document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".read-link").forEach(function (link) {
        link.addEventListener("click", function (event) {
            event.preventDefault();
            let content = link.previousElementSibling;
            if (content && content.classList.contains("metafield-rich_text_field")) {
                content.classList.toggle("opened");
                this.textContent = content.classList.contains("opened") ? "Zwiń «" : "Czytaj więcej »";
            }
        });
    });
});